import React from 'react';
import { Container, Col, Row } from '@miro-site/ui-design-system';
import { HeaderLogo } from './components/header-logo';
import { NavBarMetaMenu } from './components/meta-menu';
import { NavBar } from './components/nav-bar';
import { NavDrawerTrigger } from './components/nav-drawer';
import { NavDrawer } from './components/nav-drawer';
import { HeaderStateContextProvider } from './providers/header-state-context-provider';
import { HeaderDataContextProvider } from './providers/header-data-context-provider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Header = function Header(headerData) {
  return /*#__PURE__*/_jsx(HeaderDataContextProvider, {
    value: headerData,
    children: /*#__PURE__*/_jsxs(HeaderStateContextProvider, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "bg-white border-bottom",
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsxs(Col, {
              className: "d-flex gap-100 py-200 justify-content-between",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "d-flex",
                children: [/*#__PURE__*/_jsx(NavDrawerTrigger, {}), /*#__PURE__*/_jsx(HeaderLogo, {}), /*#__PURE__*/_jsx(NavBar, {})]
              }), /*#__PURE__*/_jsx(NavBarMetaMenu, {})]
            })
          })
        })
      }), /*#__PURE__*/_jsx(NavDrawer, {})]
    })
  });
};
export default Header;